<template>
  <div class="dashboard-page">
    <div class="header-container">
      <div class="top-bar">
        <div class="station-select" @click="showStationPopup = true">
          <i class="el-icon-lightning"></i>
          <span class="bold">{{ currentStation }}</span>
          <i class="el-icon-arrow-down"></i>
        </div>
        <div class="top-icons">
          <i class="el-icon-user" @click="$router.push('/admin/mine')"></i>
          <el-badge :value="noticeCount" class="badge-item" :hidden="!noticeCount">
            <i class="el-icon-bell"></i>
          </el-badge>
        </div>
      </div>
      <div class="sub-address">{{ currentAddress }}</div>

      <div class="stats-row">
        <div class="stat-item">
          <p class="label">当月订单总额 <i class="el-icon-arrow-right"></i></p>
          <p class="value">{{ monthStatsData.sumSales || '0.00' }}</p>
          <p class="yesterday">累计 {{ statsData.sumSales || '0.00' }}</p>
        </div>
        <div class="stat-item">
          <p class="label">当月充电度数 <i class="el-icon-arrow-right"></i></p>
          <p class="value">{{ monthStatsData.totalPowerConsumption || '0.00' }}</p>
          <p class="yesterday">累计 {{ statsData.totalPowerConsumption || '0.00' }}</p>
        </div>
        <div class="stat-item">
          <p class="label">当月订单量 <i class="el-icon-arrow-right"></i></p>
          <p class="value">{{ monthStatsData.sumCount || '0' }}</p>
          <p class="yesterday">累计 {{ statsData.sumCount || '0' }}</p>
        </div>
      </div>
    </div>

    <div class="status-card">
      <div class="status-grid">
        <div class="grid-cell"><span>离线</span><b class="gray">{{ pilesData.offLine || 0 }}</b></div>
        <div class="grid-cell"><span>故障</span><b class="orange">{{ pilesData.fault || 0 }}</b></div>
        <div class="grid-cell"><span>挂起</span><b class="orange">{{ pilesData.hangUp || 0 }}</b></div>
        <div class="grid-cell"><span>占用</span><b class="dark">{{ pilesData.occupy || 0 }}</b></div>
        <div class="grid-cell"><span>充电中</span><b class="blue">{{ pilesData.charging || 0 }}</b></div>
        <div class="grid-cell"><span>空闲</span><b class="green">{{ pilesData.free || 0 }}</b></div>
      </div>
    </div>

    <div class="menu-container">
      <div class="menu-item" v-for="(item, index) in menuList" :key="index" @click="handleMenuClick(item)">
        <div class="icon-box" :style="{ backgroundColor: item.bg }">
          <i :class="item.icon"></i>
        </div>
        <span>{{ item.title }}</span>
      </div>
    </div>

    <div class="ad-banner" v-if="adBanner.fileUrl" @click="handleAdClick">
      <div class="ad-text">
        <p class="ad-title">{{ adBanner.title }}</p>
        <p class="ad-desc">{{ adBanner.url }}</p>
      </div>
      <img :src="adBanner.fileUrl" alt="ad" />
    </div>

    <div class="todo-bar">
      <span>待办 <small>待办都完成啦~</small></span>
      <i class="el-icon-arrow-right"></i>
    </div>

    <div class="chart-section">
      <div class="section-header">
        <span class="sub-tab active">充电分布</span>
      </div>

      <div class="filter-row">
        <div class="time-tabs">
          <span :class="{active: timeRange==='7'}" @click="changeTimeRange('7')">近7天</span>
          <span :class="{active: timeRange==='30'}" @click="changeTimeRange('30')">近30天</span>
          <span :class="{active: timeRange==='12'}" @click="changeTimeRange('12')">近12月</span>
        </div>
        <span class="date-text">{{ dateRange }}</span>
      </div>

      <div class="chart-body">
        <div class="chart-unit">
          <span>度</span>
          <span>元</span>
        </div>
        <div id="bizChart" style="width: 100%; height: 200px;"></div>

        <div class="chart-legend">
          <div class="legend-item"><span class="dot cyan"></span> 充电量: {{ chartData.totalPower }}度</div>
          <div class="legend-item"><span class="dot blue"></span> 订单总额: {{ chartData.totalSales }}元</div>
          <div class="legend-item"><span class="dot yellow"></span> 充电单量: {{ chartData.totalCount }}笔</div>
        </div>
      </div>
    </div>

    <div class="footer-tab">
      <div class="tab-btn active"><i class="el-icon-s-home"></i><span>首页</span></div>
      <div class="tab-btn" @click="$router.push('/admin/realtime')"><i class="el-icon-video-play"></i><span>充电实况</span></div>
      <div class="tab-btn"><i class="el-icon-s-marketing"></i><span>经营参谋</span></div>
    </div>

    <el-dialog
      title="切换"
      :visible.sync="showStationPopup"
      width="100%"
      custom-class="bottom-dialog station-dialog"
      :show-close="true"
    >
      <div class="station-content">
        <el-input placeholder="输入场站或商户名称" prefix-icon="el-icon-search" v-model="searchKey"></el-input>

        <div class="merchant-group">
           <div class="m-title"><i class="el-icon-office-building"></i> {{ merchantName }}</div>
           <div class="station-list">
              <div class="station-item" :class="{active: currentStation === '全部场站'}" @click="selectStation('全部场站', null)">
                <div class="s-info">
                  <p class="name"><i class="el-icon-school"></i> 全部场站</p>
                  <p class="sub">共有{{ stationList.length }}个场站</p>
                </div>
                <i class="el-icon-success" v-if="currentStation === '全部场站'"></i>
                <span class="uncheck" v-else></span>
              </div>

              <div class="station-item" :class="{active: currentStation === item.plotName}" v-for="item in stationList" :key="item.id" @click="selectStation(item.plotName, item.id)">
                <div class="s-info">
                  <p class="name"><i class="el-icon-school"></i> {{ item.plotName }}</p>
                  <p class="sub">{{ item.address || '' }}</p>
                </div>
                <i class="el-icon-success" v-if="currentStation === item.plotName"></i>
                <span class="uncheck" v-else></span>
              </div>
           </div>
        </div>
        <el-button type="primary" class="confirm-btn" @click="confirmStation">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { agentPlotList, getSalesData, getSalesDetail, getPortList, getAdvertList, getDeviceStatiscs, getChargingOrderTrend } from "@/api/newApi";

export default {
  name: 'MerchantDashboard',
  data() {
    return {
      timeRange: '7',
      currentStation: '全部场站',
      currentAddress: '',
      merchantName: '',
      showStationPopup: false,
      searchKey: '',
      stationList: [],
      selectedStationId: null,
      statsData: {},
      pilesData: {
        offLine: 0,
        fault: 0,
        hangUp: 0,
        occupy: 0,
        charging: 0,
        free: 0
      },
      chartData: {
        totalPower: '0',
        totalSales: '0',
        totalCount: '0'
      },
      dateRange: '',
      chartDates: [],
      chartPowerData: [],
      chartSalesData: [],
      chartCountData: [],
      monthStatsData: {
        sumSales: '0.00',
        totalPowerConsumption: '0.00',
        sumCount: '0'
      },
      noticeCount: 0,
      adBanner: {
        fileUrl: '',
        title: '',
        url: ''
      },
      menuList: [
        { title: '订单管理', icon: 'el-icon-document', bg: '#4A81FF', path: '/admin/orderManage' },
        { title: '我的钱包', icon: 'el-icon-wallet', bg: '#FF9546', path: '/wallet' },
        { title: '结算日报', icon: 'el-icon-date', bg: '#FF9546', path: '/daily' },
        { title: '站点管理', icon: 'el-icon-office-building', bg: '#1BC48D', path: '/stationManage' },
        { title: '规则管理', icon: 'el-icon-s-order', bg: '#FF6B6B', path: '/admin/rules' },
        { title: '促销管理', icon: 'el-icon-s-marketing', bg: '#4ECDC4', path: '/admin/promotion' },
        { title: '广告管理', icon: 'el-icon-picture', bg: '#9B59B6', path: '/admin/advert' },
        { title: '反馈管理', icon: 'el-icon-chat-dot-square', bg: '#3498DB', path: '/admin/response' },
        { title: '卡管理', icon: 'el-icon-postcard', bg: '#F39C12', path: '/admin/card' }
      ]
    };
  },
  watch: {
    timeRange(newVal) {
      this.getChartData();
    }
  },
  mounted() {
    this.getStationList();
    this.getStatsData();
    this.getChartData();
    this.getAdBanner();
  },
  methods: {
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    handleMenuClick(item) {
      if (item.path && item.path !== '/more') {
        this.$router.push(item.path);
      }
    },
    changeTimeRange(range) {
      this.timeRange = range;
    },
    handleAdClick() {
      if (this.adBanner.url) {
        window.location.href = this.adBanner.url;
      }
    },
    selectStation(name, id) {
      this.currentStation = name;
      this.selectedStationId = id;
      if (id) {
        const station = this.stationList.find(s => s.id === id);
        if (station) {
          this.currentAddress = station.address || '';
        }
      } else {
        this.currentAddress = this.merchantName || '';
      }
    },
    confirmStation() {
      this.showStationPopup = false;
      this.getStatsData();
      this.getChartData();
    },
    async getStationList() {
      try {
        const res = await agentPlotList({});
        if (res.data && res.data.length > 0) {
          this.stationList = res.data;
          this.merchantName = res.data[0].merchantName || '商户';
          this.currentAddress = this.merchantName;
        }
      } catch (err) {
        console.log('获取场站列表失败', err);
      }
    },
    async getStatsData() {
      try {
        const res = await getSalesData();
        if (res.data) {
          this.statsData = res.data;
          this.pilesData.offLine = res.data.offLine || 0;
          this.updateChartData(res.data);
        }
        await this.getPortStatusData();
        await this.getMonthData();
      } catch (err) {
        console.log('获取统计数据失败', err);
      }
    },
    async getAdBanner() {
      try {
        const res = await getAdvertList({ pageNo: 1, pageSize: 1 });
        if (res.data && res.data.records && res.data.records.length > 0) {
          this.adBanner = res.data.records[0];
        }
      } catch (err) {
        console.log('获取广告失败', err);
      }
    },
    async getMonthData() {
      try {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const monthStart = `${year}-${month}-01`;
        const monthPrefix = `${year}-${month}`;

        console.log('查询当月数据, 日期前缀:', monthPrefix);

        const res = await getSalesDetail({
          pageNo: 1,
          pageSize: 1000
        });

        console.log('当月数据返回:', res);

        if (res.data && res.data.records && res.data.records.length > 0) {
          let sumSales = 0;
          let totalPower = 0;
          let sumCount = 0;

          res.data.records.forEach(item => {
            if (item.createTime && item.createTime.startsWith(monthPrefix)) {
              console.log('当月记录项:', item);
              sumSales += parseFloat(item.sumSales || 0);
              totalPower += parseFloat(item.totalPowerConsumption || 0);
              sumCount += parseInt(item.sumCount || 0);
            }
          });

          this.monthStatsData = {
            sumSales: sumSales.toFixed(2),
            totalPowerConsumption: totalPower.toFixed(2),
            sumCount: sumCount
          };
        } else {
          this.monthStatsData = {
            sumSales: '0.00',
            totalPowerConsumption: '0.00',
            sumCount: '0'
          };
        }
      } catch (err) {
        console.log('获取当月数据失败', err);
      }
    },
    async getPortStatusData() {
      try {
        const res = await getDeviceStatiscs({});
        if (res.data) {
          this.pilesData.offLine = res.data.slowDeviceOffCount || 0;
          this.pilesData.fault = res.data.slowDeviceWaringCount || 0;
          this.pilesData.free = res.data.slowDeviceFreeCount || 0;
          this.pilesData.charging = res.data.slowDeviceUseCount || 0;
          this.pilesData.occupy = res.data.slowDeviceOccupancyCount || 0;
          this.pilesData.hangUp = res.data.slowDeviceInsertCount || 0;
        }
      } catch (err) {
        console.log('获取端口状态数据失败', err);
      }
    },
    async getChartData() {
      try {
        const cycleMap = { '7': 1, '30': 2, '12': 3 };
        const cycleType = cycleMap[this.timeRange] || 1;
        const now = new Date();
        let startTime = '';
        if (this.timeRange === '7') {
          const d = new Date(now.getTime() - 6 * 24 * 60 * 60 * 1000);
          startTime = this.formatDate(d);
        } else if (this.timeRange === '30') {
          const d = new Date(now.getTime() - 29 * 24 * 60 * 60 * 1000);
          startTime = this.formatDate(d);
        } else if (this.timeRange === '12') {
          const d = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
          startTime = this.formatDate(d);
        }
        const endTime = this.formatDate(now);
        const res = await getChargingOrderTrend({ startTime, endTime, cycleType });
        let records = [];
        if (res.data && res.data.records && res.data.records.length > 0) {
          records = res.data.records;
        } else if (res.data && Array.isArray(res.data) && res.data.length > 0) {
          records = res.data;
        }
        if (records.length > 0) {
          this.chartDates = records.map(r => r.chargingDate || '');
          this.chartPowerData = records.map(r => r.consumePowerTotal || 0);
          this.chartSalesData = records.map(r => r.ordergoldTotal || 0);
          this.chartCountData = records.map(r => r.chargingCount || 0);
          const first = records[records.length - 1];
          const last = records[0];
          this.dateRange = `${first.registerDate} ~ ${last.registerDate}`;
          const totalPower = records.reduce((sum, r) => sum + (r.consumePowerTotal || 0), 0);
          const totalSales = records.reduce((sum, r) => sum + (r.ordergoldTotal || 0), 0);
          const totalCount = records.reduce((sum, r) => sum + (r.chargingCount || 0), 0);
          this.chartData = {
            totalPower: totalPower.toFixed(2),
            totalSales: totalSales.toFixed(2),
            totalCount: totalCount
          };
          this.initChart();
        } else {
          this.initChart();
        }
      } catch (err) {
        console.log('获取图表数据失败', err);
        this.initChart();
      }
    },
    updateChartData(data) {
      this.chartData = {
        totalPower: data.consumePowerTotal || '0',
        totalSales: data.ordergoldTotal || '0',
        totalCount: data.chargingCount || '0'
      };
    },
    initChart() {
      const chartDom = document.getElementById('bizChart');
      if (!chartDom) return;
      echarts.dispose(chartDom);
      const myChart = echarts.init(chartDom);
      const dates = this.chartDates.length > 0 ? this.chartDates : ['4.8', '4.9', '4.10', '4.11', '4.12', '4.13', '4.14'];
      const powerData = this.chartPowerData.length > 0 ? this.chartPowerData : [160, 180, 110, 350, 340, 50, 110];
      const salesData = this.chartSalesData.length > 0 ? this.chartSalesData : [150, 175, 100, 260, 290, 45, 95];
      const option = {
        grid: { top: 10, left: 35, right: 35, bottom: 20 },
        xAxis: {
          type: 'category',
          data: dates,
          axisLine: { lineStyle: { color: '#EEE' } },
          axisLabel: { color: '#999', fontSize: 10, interval: dates.length > 7 ? Math.floor(dates.length / 7) : 0, rotate: dates.length > 7 ? 45 : 0 }
        },
        yAxis: {
          type: 'value',
          splitLine: { lineStyle: { type: 'dashed', color: '#F0F0F0' } },
          axisLabel: { color: '#999', fontSize: 10 }
        },
        series: [
          {
            name: '充电量',
            data: powerData,
            type: 'line',
            smooth: true,
            symbol: 'none',
            color: '#2CC9E1',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(44, 201, 225, 0.2)' },
                { offset: 1, color: 'rgba(44, 201, 225, 0)' }
              ])
            }
          },
          {
            name: '订单总额',
            data: salesData,
            type: 'line',
            smooth: true,
            symbol: 'none',
            color: '#4A81FF'
          }
        ]
      };
      myChart.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped>
.dashboard-page {
  background-color: #F8FAFB;
  min-height: 100vh;
  padding-bottom: 70px;
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #333;
}

.header-container {
  background: linear-gradient(180deg, #D4F4F1 0%, #F8FAFB 100%);
  padding: 15px 16px 10px;

  .top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .station-select {
      display: flex;
      align-items: center;
      font-size: 18px;
      i:first-child { color: #00BFA5; margin-right: 5px; }
      i:last-child { font-size: 14px; margin-left: 4px; color: #666; }
      .bold { font-weight: bold; }
    }
    .top-icons i {
      font-size: 22px;
      margin-left: 15px;
      color: #333;
    }
  }
  .sub-address {
    font-size: 12px;
    color: #999;
    margin: 6px 0 15px 25px;
  }
}

.stats-row {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  .stat-item {
    flex: 1;
    .label { font-size: 13px; color: #666; margin-bottom: 8px; i { font-size: 10px; } }
    .value { font-size: 24px; font-weight: bold; margin-bottom: 5px; }
    .yesterday { font-size: 12px; color: #BBB; }
  }
}

.status-card {
  background: #FFF;
  margin: 12px 16px;
  border-radius: 12px;
  padding: 15px 10px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.03);
  .status-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    .grid-cell {
      display: flex;
      flex-direction: column;
      align-items: center;
      span { font-size: 12px; color: #999; margin-bottom: 6px; }
      b { font-size: 16px;
        &.gray { color: #DDD; }
        &.orange { color: #FF9546; }
        &.blue { color: #4A81FF; }
        &.green { color: #1BC48D; }
        &.dark { color: #333; }
      }
    }
  }
}

.menu-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  padding: 10px 8px;
  .menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 15px;
    .icon-box {
      width: 42px;
      height: 42px;
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 6px;
      i { color: #FFF; font-size: 20px; }
    }
    span { font-size: 12px; color: #444; }
  }
}

.ad-banner {
  background: #FFF;
  margin: 0 16px 12px;
  border-radius: 10px;
  padding: 12px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(90deg, #E6F7FF 0%, #FFFFFF 100%);
  .ad-title { font-size: 15px; color: #2CC9E1; .bold { font-weight: bold; color: #333; } }
  .ad-desc { font-size: 12px; color: #999; margin-top: 4px; }
  img { width: 50px; }
}

.todo-bar {
  background: #FFF;
  margin: 0 16px 12px;
  padding: 15px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span { font-size: 15px; font-weight: bold; small { font-weight: normal; color: #BBB; margin-left: 10px; } }
  i { color: #CCC; }
}

.chart-section {
  background: #FFF;
  padding: 15px 16px;
  .section-header {
    margin-bottom: 15px;
    .main-title { font-size: 16px; font-weight: bold; margin-right: 15px; color: #999; }
    .sub-tab { font-size: 16px; font-weight: bold; &.active { color: #333; border-bottom: 3px solid #00BFA5; padding-bottom: 4px; } }
  }
  .filter-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    .time-tabs {
      background: #F0F2F5;
      padding: 3px;
      border-radius: 6px;
      span { font-size: 12px; padding: 4px 10px; display: inline-block; border-radius: 4px; color: #666;
        &.active { background: #FFF; color: #2CC9E1; font-weight: bold; }
      }
    }
    .date-text { font-size: 11px; color: #BBB; }
  }
  .chart-body {
    position: relative;
    .chart-unit {
      display: flex;
      justify-content: space-between;
      font-size: 11px;
      color: #CCC;
      padding: 0 5px;
    }
    .chart-legend {
      margin-top: 10px;
      .legend-item { font-size: 12px; color: #666; margin-bottom: 5px;
        .dot { width: 8px; height: 8px; border-radius: 50%; display: inline-block; margin-right: 5px; }
        .dot.cyan { background: #2CC9E1; }
        .dot.blue { background: #4A81FF; }
        .dot.yellow { background: #FFC107; }
        .up { color: #FF4D4F; margin-left: 5px; }
      }
    }
  }
}

.footer-tab {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 55px;
  background: #FFF;
  display: flex;
  border-top: 1px solid #EEE;
  .tab-btn {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #999;
    i { font-size: 22px; }
    span { font-size: 11px; margin-top: 2px; }
    &.active { color: #00BFA5; }
  }
}

.bottom-dialog {
  margin: 0 !important;
  position: fixed !important;
  bottom: 0;
  border-radius: 20px 20px 0 0 !important;
  .el-dialog__header { display: none; }
  .el-dialog__body { padding: 20px; }
}

.station-dialog {
  .station-content {
    .m-title {
      margin: 20px 0 15px;
      font-size: 14px;
      color: #333;
      i { color: #00BFA5; margin-right: 5px; }
    }
    .station-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      border-bottom: 1px solid #f5f5f5;
      .name { font-weight: bold; font-size: 15px; i { color: #4A81FF; } }
      .sub { font-size: 12px; color: #999; margin-top: 5px; }
      .el-icon-success { color: #00BFA5; font-size: 20px; }
      .uncheck { width: 18px; height: 18px; border: 1px solid #ddd; border-radius: 50%; }
    }
    .confirm-btn {
      width: 100%;
      margin-top: 30px;
      background: #00BFA5;
      border: none;
      border-radius: 25px;
      height: 45px;
    }
  }
}
</style>
